var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("summary-section-layout", {
    attrs: {
      id: "identifications",
      "section-title": _vm.$t("application-standalone.labels.identifications"),
      "has-missing-information": _vm.hasMissingInformation,
    },
    on: {
      edit: function ($event) {
        return _vm.$emit("edit")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var applicant = ref.applicant
          return [
            !_vm.applicantHasIdentification(applicant.identifications)
              ? _c("p", { staticClass: "grey-text" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "application-standalone.pages.identifications.noIdentifications"
                        )
                      ) +
                      "\n    "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(
              applicant.identifications,
              function (identification, identificationIndex) {
                return _c("p", { key: identificationIndex }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.identificationSummarySubtitle(identification)
                      ) +
                      "\n    "
                  ),
                ])
              }
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }